// extracted by mini-css-extract-plugin
module.exports = {"dataService":"DataService_dataService__32wqB","service":"DataService_service__2pVYm","btn":"DataService_btn__19m94"};